export default "__VITE_ASSET__COXTHK9$__"